/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, ProgressBar, Row, Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";

import produtosEmUsoService from "../../api/atendimentos/produtosEmUsoService";
import tratamentosService from "../../api/atendimentos/tratamentosService";
import {
    faixasAtrasoDose,
    formataDataExibicao,
    motivosNaoRealizacaoTratamento,
    statusAplicacaoTratamento,
} from "../../common/utils";

const VARIANTES_ATRASO = {
    sem_atraso: "success",
    ate_7_dias: "info",
    de_8_a_30_dias: "warning",
    acima_30_dias: "danger",
};

class ComplianceMedicamentosoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            salvando: false,
            erro: "",
            compliance: null,
            tratamentos: [],
            produtosEmUso: [],
            showModal: false,
            formulario: this.getFormularioInicial(),
        };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    getFormularioInicial = () => ({
        id: null,
        produto_uso_id: "",
        data_prevista: "",
        status: "realizado",
        data_realizacao: "",
        motivo_nao_realizacao: "atraso_recebimento_produto",
        motivo_outros: "",
    });

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, compliance: null, tratamentos: [] });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const [respCompliance, respTratamentos, respProdutos] = await Promise.all([
                tratamentosService.compliance(atendimentoId),
                tratamentosService.listar(atendimentoId),
                produtosEmUsoService.listar(atendimentoId),
            ]);

            this.setState({
                loading: false,
                compliance: respCompliance.data || null,
                tratamentos: respTratamentos.data?.resultados || [],
                produtosEmUso: respProdutos.data?.resultados || [],
            });
        } catch (error) {
            console.error("Erro ao carregar compliance medicamentoso:", error);
            this.setState({
                loading: false,
                erro: this.getMensagemErro(error, "Não foi possível carregar o compliance medicamentoso."),
            });
        }
    };

    abrirModal = () => this.setState({ showModal: true, formulario: this.getFormularioInicial() });

    fecharModal = () => this.setState({ showModal: false, formulario: this.getFormularioInicial() });

    onChange = (event) => {
        const { name, value } = event.target;
        this.setState((estado) => ({ formulario: { ...estado.formulario, [name]: value } }));
    };

    salvar = async () => {
        const { formulario } = this.state;

        if (!formulario.produto_uso_id) {
            Swal.fire("Atenção", "Selecione o medicamento.", "warning");
            return;
        }

        if (!formulario.data_prevista) {
            Swal.fire("Atenção", "Informe a data prevista.", "warning");
            return;
        }

        if (formulario.status === "realizado" && !formulario.data_realizacao) {
            Swal.fire("Atenção", "Informe a data de realização.", "warning");
            return;
        }

        if (formulario.status === "nao_realizado" && formulario.motivo_nao_realizacao === "outros" && !formulario.motivo_outros.trim()) {
            Swal.fire("Atenção", 'A descrição é obrigatória quando o motivo é "Outros".', "warning");
            return;
        }

        const payload = {
            produto_uso_id: formulario.produto_uso_id,
            data_prevista: formulario.data_prevista,
            status: formulario.status,
        };

        if (formulario.status === "realizado") {
            payload.data_realizacao = formulario.data_realizacao;
        } else {
            payload.motivo_nao_realizacao = formulario.motivo_nao_realizacao;
            payload.motivo_outros = formulario.motivo_outros.trim();
        }

        this.setState({ salvando: true });

        try {
            await tratamentosService.create(payload);
            this.setState({ salvando: false, showModal: false, formulario: this.getFormularioInicial() });
            await this.carregar();
            Swal.fire("Sucesso", "Tratamento registrado com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao registrar tratamento:", error);
            this.setState({ salvando: false });
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível registrar o tratamento."), "error");
        }
    };

    excluir = async (registro) => {
        const confirmacao = await Swal.fire({
            title: "Confirmar exclusão?",
            text: "Deseja remover este registro de tratamento? O compliance será recalculado.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar",
        });

        if (!confirmacao.isConfirmed) {
            return;
        }

        try {
            await tratamentosService.delete(registro.id);
            await this.carregar();
            Swal.fire("Sucesso", "Registro removido com sucesso.", "success");
        } catch (error) {
            console.error("Erro ao remover tratamento:", error);
            Swal.fire("Erro", this.getMensagemErro(error, "Não foi possível remover o registro."), "error");
        }
    };

    renderIndicador = () => {
        const { compliance } = this.state;

        if (!compliance) {
            return null;
        }

        const valor = compliance.compliance;
        const variante = valor === null ? "secondary" : valor >= 90 ? "success" : valor >= 70 ? "warning" : "danger";

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <Row className="align-items-center">
                        <Col sm={12} lg={4}>
                            <h5 className="mb-1">Compliance Medicamentoso</h5>
                            <small className="text-muted">
                                Tratamentos realizados ÷ previstos × 100
                            </small>
                        </Col>
                        <Col sm={12} lg={8}>
                            {valor === null ? (
                                <Alert variant="light" className="mb-0">
                                    Sem medicamentos com periodicidade projetável para calcular o indicador.
                                </Alert>
                            ) : (
                                <>
                                    <div className="d-flex justify-content-between align-items-end mb-1">
                                        <span className="h3 mb-0">{valor}%</span>
                                        <small className="text-muted">
                                            {compliance.tratamentos_realizados} de {compliance.tratamentos_previstos} tratamentos
                                        </small>
                                    </div>
                                    <ProgressBar now={valor} variant={variante} />
                                </>
                            )}
                        </Col>
                    </Row>

                    {(compliance.detalhes_por_produto || []).length > 0 && (
                        <Table responsive className="custom-table table-sm align-middle mt-4 mb-0">
                            <thead>
                                <tr>
                                    <th>Medicamento</th>
                                    <th>Frequência</th>
                                    <th>Previstos</th>
                                    <th>Realizados</th>
                                    <th>Não realizados</th>
                                    <th>Compliance</th>
                                    <th>Atraso de dose</th>
                                </tr>
                            </thead>
                            <tbody>
                                {compliance.detalhes_por_produto.map((item) => (
                                    <tr key={item.produto_uso_id}>
                                        <td>{item.produto || "-"}</td>
                                        <td>{item.frequencia_display || "-"}</td>
                                        <td>{item.periodicidade_projetavel ? item.tratamentos_previstos : "-"}</td>
                                        <td>{item.tratamentos_realizados}</td>
                                        <td>{item.tratamentos_nao_realizados}</td>
                                        <td>{item.compliance === null ? "-" : `${item.compliance}%`}</td>
                                        <td>
                                            <Badge bg={VARIANTES_ATRASO[item.maior_faixa_atraso] || "secondary"}>
                                                {faixasAtrasoDose[item.maior_faixa_atraso] || "-"}
                                            </Badge>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </Card.Body>
            </Card>
        );
    };

    renderModal = () => {
        const { showModal, formulario, salvando, produtosEmUso } = this.state;

        return (
            <Modal show={showModal} onHide={this.fecharModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Registrar tratamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className="mb-3">
                            <Form.Label>Medicamento *</Form.Label>
                            <Form.Select name="produto_uso_id" value={formulario.produto_uso_id} onChange={this.onChange}>
                                <option value="">Selecione</option>
                                {produtosEmUso.map((produto) => (
                                    <option key={produto.id} value={produto.id}>
                                        {produto.dados_produto?.nome} — {produto.dose} ({produto.frequencia_uso})
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Data prevista *</Form.Label>
                            <Form.Control type="date" name="data_prevista" value={formulario.data_prevista} onChange={this.onChange} />
                        </Col>
                        <Col sm={6} className="mb-3">
                            <Form.Label>Status *</Form.Label>
                            <Form.Select name="status" value={formulario.status} onChange={this.onChange}>
                                {Object.entries(statusAplicacaoTratamento).map(([valor, label]) => (
                                    <option key={valor} value={valor}>
                                        {label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>

                        {formulario.status === "realizado" ? (
                            <Col sm={6} className="mb-3">
                                <Form.Label>Data de realização *</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="data_realizacao"
                                    max={new Date().toISOString().slice(0, 10)}
                                    value={formulario.data_realizacao}
                                    onChange={this.onChange}
                                />
                                <Form.Text className="text-muted">Informar após confirmação do paciente.</Form.Text>
                            </Col>
                        ) : (
                            <>
                                <Col sm={12} className="mb-3">
                                    <Form.Label>Motivo da não realização *</Form.Label>
                                    <Form.Select name="motivo_nao_realizacao" value={formulario.motivo_nao_realizacao} onChange={this.onChange}>
                                        {Object.entries(motivosNaoRealizacaoTratamento).map(([valor, label]) => (
                                            <option key={valor} value={valor}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                {formulario.motivo_nao_realizacao === "outros" && (
                                    <Col sm={12} className="mb-3">
                                        <Form.Label>Descrição complementar *</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="motivo_outros"
                                            value={formulario.motivo_outros}
                                            onChange={this.onChange}
                                        />
                                    </Col>
                                )}
                            </>
                        )}
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.fecharModal} disabled={salvando}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={this.salvar} disabled={salvando}>
                        {salvando ? "Salvando..." : "Salvar"}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { podeEditar } = this.props;
        const { loading, erro, tratamentos } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-4">
                    <Spinner animation="border" />
                </div>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        return (
            <>
                {this.renderIndicador()}

                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={8}>
                                <h5 className="mb-0">Tratamentos Registrados</h5>
                            </Col>
                            <Col sm={4} className="text-end">
                                {podeEditar && (
                                    <Button variant="outline-primary" size="sm" onClick={this.abrirModal}>
                                        Registrar tratamento
                                    </Button>
                                )}
                            </Col>
                        </Row>

                        <Table responsive className="custom-table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Medicamento</th>
                                    <th>Data prevista</th>
                                    <th>Status</th>
                                    <th>Data de realização</th>
                                    <th>Motivo</th>
                                    <th>Atraso de dose</th>
                                    {podeEditar && <th className="text-end">Ações</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {tratamentos.length === 0 ? (
                                    <tr>
                                        <td colSpan={podeEditar ? 7 : 6} className="text-center">
                                            Nenhum tratamento registrado.
                                        </td>
                                    </tr>
                                ) : (
                                    tratamentos.map((registro) => (
                                        <tr key={registro.id}>
                                            <td>{registro.dados_produto?.nome || "-"}</td>
                                            <td>{formataDataExibicao(registro.data_prevista)}</td>
                                            <td>
                                                <Badge bg={registro.status === "realizado" ? "success" : "secondary"}>
                                                    {registro.status_display}
                                                </Badge>
                                            </td>
                                            <td>{registro.data_realizacao ? formataDataExibicao(registro.data_realizacao) : "-"}</td>
                                            <td>
                                                {registro.motivo_display || "-"}
                                                {registro.motivo_outros && (
                                                    <small className="text-muted d-block">{registro.motivo_outros}</small>
                                                )}
                                            </td>
                                            <td>
                                                {registro.faixa_atraso ? (
                                                    <Badge bg={VARIANTES_ATRASO[registro.faixa_atraso] || "secondary"}>
                                                        {registro.faixa_atraso_display}
                                                        {registro.atraso_dias ? ` (${registro.atraso_dias}d)` : ""}
                                                    </Badge>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            {podeEditar && (
                                                <td className="text-end">
                                                    <Button variant="outline-danger" size="sm" onClick={() => this.excluir(registro)}>
                                                        Remover
                                                    </Button>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                {this.renderModal()}
            </>
        );
    }
}

export default ComplianceMedicamentosoAtendimento;
